@if (for.invalid && (for.dirty || for.touched)) {
  <div class="sh-error">
    @for (errorMessage of errors; track errorMessage) {
      <ul class="sh-error__list">
        <li class="sh-error__list-item">&hellip; {{ errorMessage }}</li>
      </ul>
    }
  </div>
}
